import React, { useState } from "react";
import { Container, Tab, Tabs, Typography } from "@mui/material";

import SettingsIcon from "@mui/icons-material/Settings";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import BusinessIcon from "@mui/icons-material/Business";
import KanbanConfig from "./KanbanConfig";
import GlobalSettings from "./GlobalSettings";
import EntityConfig from "./EntityConfig";

function Config() {
  const [tab, setTab] = useState("global");

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>Configuración</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Ajustes generales de la plataforma, entidades y configuración de tableros.
      </Typography>

      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{ mb: 1, borderBottom: 1, borderColor: "divider" }}
      >
        <Tab value="global" icon={<SettingsIcon />} iconPosition="start" label="Ajustes generales" />
        {/* Entidades vive aquí y no dentro de Convenios: la consumen Convenios
            hoy y Contratos mañana, así que no cuelga de ningún módulo. */}
        <Tab value="entities" icon={<BusinessIcon />} iconPosition="start" label="Entidades" />
        <Tab value="kanban" icon={<ViewKanbanIcon />} iconPosition="start" label="Kanban" />
      </Tabs>

      {tab === "global" && <GlobalSettings />}
      {tab === "entities" && <EntityConfig />}
      {tab === "kanban" && <KanbanConfig />}
    </Container>
  );
}

export default Config;
